import { generateTranslationHook } from "../utils/translation-hook-generator";

export type CommonMessages = typeof import("../../../locales/en/common.json");

export const useCommonTranslations =
	generateTranslationHook<CommonMessages>("common");
